import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSBC } from 'API/SBC/updateSBC';

const useUpdateSBC = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const update = async (sbcData) => {
        const response = await updateSBC(sbcData);
        return response.data;
    };

    return useMutation({
        mutationFn: update,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ['SBCs', variables.locationID],
            });
            queryClient.invalidateQueries({
                queryKey: ['SBC', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateSBC;
